import React, { useState, useEffect } from 'react'
import RightPanel from 'components/RightPanel/RightPanel'
import VendorList from 'features/Vendors/components/VendorList'
import AdminPanelCN from 'components/AdminPanelCN/AdminPanelCN'
import HeaderCN from 'components/HeaderCN/HeaderCN'
import Locations from './components/Locations/Locations'
import SidebarLocationsRecent from 'components/Sidebars/SidebarLocationsRecent'
import useIsMobile from 'hooks/useIsMobile'
import useIsPhone from 'hooks/useIsPhone'
import { resolveViewMode } from './viewMode'
import { Handshake } from 'lucide-react'
import MobileBackButton from 'components/MobileBackButton'

type ViewMode = 'cards' | 'table' | 'map'

const VIEW_MODE_KEY = 'locationsViewMode'

const Locations_IndexCN = () => {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
	const isMobile = useIsMobile()
	const isPhone = useIsPhone()

	const [viewMode, setViewMode] = useState<ViewMode>(() => {
		const stored = localStorage.getItem(VIEW_MODE_KEY)
		if (stored === 'cards' || stored === 'table' || stored === 'map') return stored
		// Migrate old boolean preference
		const oldStored = localStorage.getItem('cardDisplayPreference')
		if (oldStored === 'false') return 'table'
		return 'cards'
	})

	// Persists the RAW preference, never the effective one. Switching this to
	// effectiveViewMode would let a single phone visit permanently overwrite the
	// user's desktop Cards choice.
	useEffect(() => {
		localStorage.setItem(VIEW_MODE_KEY, viewMode)
	}, [viewMode])

	// Phones are List only: Cards went in MYD-386 and Map in MYD-400, so a stored
	// 'map' must NOT pass through — there is no toggle left to get back out with.
	// Tablets (768-1023px) keep every view since MYD-560; the card grid reflows.
	// The stored preference is untouched and applies again on a wider screen.
	const effectiveViewMode: ViewMode = resolveViewMode(viewMode, isPhone, { mapOnMobile: false })

	return (
		<div className="flex h-screen overflow-hidden bg-gray-50">
			<AdminPanelCN mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />

			<div className="flex-1 flex flex-col overflow-hidden">
				<HeaderCN onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />

				<div className="flex-1 flex overflow-hidden">
					<main className="flex-1 overflow-y-auto p-6">
						{/* The close button self-gates on viewport, so this row is the same
						    shape on desktop with nothing rendered on the right. */}
						<div className="flex items-center justify-between gap-3 mb-4">
							<h2 className="text-2xl font-semibold text-gray-800">Locations</h2>
							<MobileBackButton mode="close" />
						</div>
						<Locations
							viewMode={effectiveViewMode}
							onViewModeChange={setViewMode}
							isMobile={isMobile}
							listOnly={isPhone}
						/>
					</main>

					<RightPanel storageKey="locations" label="Locations panel">
						<div className="flex flex-col h-1/2 border-b border-gray-200 overflow-y-auto">
							<SidebarLocationsRecent />
						</div>
						{/* Vendor Partnerships card — bottom half */}
						<div className="flex flex-col h-1/2">
							<div className="px-4 py-3 border-b border-gray-100">
								<span className="flex items-center gap-2 text-gray-600 text-base font-semibold hover:scale-105 transition-transform duration-150">
									<Handshake className="w-4 h-4" /> Vendor Partnerships
								</span>
							</div>
							<div className="flex-1 overflow-y-auto">
								<VendorList />
							</div>
						</div>
					</RightPanel>
				</div>
			</div>
		</div>
	)
}

export default Locations_IndexCN
